import { render, staticRenderFns } from "./actions-cell.vue?vue&type=template&id=5f94811f&scoped=true&"
import script from "./actions-cell.vue?vue&type=script&lang=js&"
export * from "./actions-cell.vue?vue&type=script&lang=js&"
import style0 from "./actions-cell.vue?vue&type=style&index=0&id=5f94811f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f94811f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f94811f')) {
      api.createRecord('5f94811f', component.options)
    } else {
      api.reload('5f94811f', component.options)
    }
    module.hot.accept("./actions-cell.vue?vue&type=template&id=5f94811f&scoped=true&", function () {
      api.rerender('5f94811f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-table/violations/actions-cell.vue"
export default component.exports